import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function CustomerBilledCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {

  $scope.showBillerCustomers = !!$scope.customers.length;
  $scope.tableCacheKey       = 'billedCustomers';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.COMPANY')
        },
        classes: 'all-caps'
      },
      {
        field : 'phone',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.PHONE')
        }
      },
      {
        field : 'email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewCustomer(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CUSTOMERS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/biller_child_count', $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getCustomers = ( params ) => {
    return workshopAPI.get('/customers/biller_child_list', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
    ]).then(customers => {
      $scope.customers = customers;

      return customers;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewCustomer(event.row)
  };

  $scope.viewCustomer = function (customer) {
    $state.go('app.customer', {
      id: customer.id
    });
  };
}